export default __webpack_public_path__ + "static/media/banner.869e4e2b.jpg";